import { Room } from 'livekit-client'
import {
  registerRouteObserver,
  unregisterRouteObserver,
} from 'modules/ai_voice/lib/observers/route'
import {
  registerClickObserver,
  unregisterClickObserver,
} from 'modules/ai_voice/lib/observers/click'
import { registerTypeObserver, unregisterTypeObserver } from 'modules/ai_voice/lib/observers/type'
import {
  registerSelectObserver,
  unregisterSelectObserver,
} from 'modules/ai_voice/lib/observers/select'

export function registerObservers(room: Room): void {
  registerRouteObserver(room)
  registerClickObserver(room)
  registerTypeObserver(room)
  registerSelectObserver(room)
}

export function unregisterObservers(): void {
  unregisterRouteObserver()
  unregisterClickObserver()
  unregisterTypeObserver()
  unregisterSelectObserver()
}
